@if (href()) {
  <a
    class="relative flex--inline"
    [finLink]="href()"
    [external]="externalLink()"
    [openInNewTab]="openInNewTab()"
    [class]="theme()"
    [attr.title]="title()"
    [attr.aria-label]="aria().label"
    [attr.aria-describedby]="aria()?.describedby"
    [attr.aria-controls]="aria()?.controls"
    [attr.role]="'link'"
    [attr.aria-disabled]="aria()?.disabled"
    [attr.aria-hidden]="aria()?.hidden"
    (beforeNavigation)="onClick($event)"
  >
    <ng-container *ngTemplateOutlet="iconTemplate" />
  </a>
} @else {
  <button
    (click)="onClick($event)"
    [type]="type()"
    class="relative"
    [class]="theme()"
    [disabled]="disabled()"
    [attr.title]="title()"
    [attr.aria-label]="aria().label"
    [attr.aria-describedby]="aria()?.describedby"
    [attr.aria-controls]="aria()?.controls"
    [attr.role]="'button'"
    [attr.aria-disabled]="aria()?.disabled"
    [attr.aria-hidden]="aria()?.hidden"
    [attr.data-testid]="dataTestId()"
  >
    <ng-container *ngTemplateOutlet="iconTemplate" />
  </button>
}

<ng-template #iconTemplate>
  <span class="flex" [class]="size()">
    <fcom-icon
      [category]="icon().category"
      [name]="icon().name"
      [ngClass]="{
        'icon-small': size() === IconButtonSize.SMALL,
        'icon-medium': size() === IconButtonSize.MEDIUM || size() === IconButtonSize.LARGE,
      }"
    />
  </span>
</ng-template>
